module.exports = __webpack_public_path__ + "static/media/I Don't Know What's Gonna Kill Me.89ebf17e.jpg";